"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lista = void 0;
var _index = _interopRequireDefault(require("./index.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var lista = exports.lista = _index.default;